export default "__VITE_PUBLIC_ASSET__3c1da63a__"